import React, { createContext, useContext } from "react";

const ApiContext = createContext();

export const ApiProvider = ({ children }) => {
  const baseUrl = "https://redroseworkout.ir/api/v2";

  return <ApiContext.Provider value={baseUrl}>{children}</ApiContext.Provider>;
};

export const useBaseUrl = () => useContext(ApiContext);
